module.exports = __webpack_public_path__ + "img/max-file-configure.d7cac542.svg";